import { Controller } from "@hotwired/stimulus";
import Drawflow from "drawflow";

export default class extends Controller {
  connect() {
    window._stagedFlow = { fases: {} };
    window._usedNodes = [0]
    
    // 🧩 Rehydrate existing fases from hidden input
    const fasesInput = document.querySelector('[data-modelo-fluxo-form-target="fasesInput"]');
    if (fasesInput && fasesInput.value) {
      try {
        const parsed = JSON.parse(fasesInput.value);
        if (parsed.fases) {
          window._stagedFlow.fases = parsed.fases;
          for (const key in parsed.fases) {
            const fase = parsed.fases[key];
            if (fase.drawflowId) window._usedNodes.push(fase.drawflowId);
          }

          // Optional: Re-add all nodes to Drawflow
          // Object.entries(parsed.fases).forEach(([nodeId, fase]) => {
          //   // Only create visually if Drawflow is empty or doesn't have it yet
          //   const alreadyExists = this.editor.getNodeFromId?.(fase.drawflowId);
          //   if (!alreadyExists) {
          //     const drawflowId = this.addNode(
          //       nodeId,
          //       fase.nome,
          //       fase.perfis?.map((p) => p.nome) || []
          //     );
          //     window._stagedFlow.fases[nodeId].drawflowId = drawflowId;
          //   }
          // });
        }
      } catch (err) {
        console.warn("Failed to parse fases_data:", err);
      }
    }

    this.editor = new Drawflow(this.element);
    this.editor.reroute = true;
    this.editor.reroute_fix_curvature = true;

    // Set curvature values to 0 for straight lines
    // this.editor.curvature = 0;
    // this.editor.reroute_curvature_start_end = 0;
    // this.editor.reroute_curvature = 0;

    // // Define a custom createCurvature function to draw straight lines
    // this.editor.createCurvature = function(start_pos_x, start_pos_y, end_pos_x, end_pos_y) {
    //   // This function now draws a straight line directly from start to end
    //   return 'M ' + start_pos_x + ' ' + start_pos_y + ' L ' + end_pos_x + ' ' + end_pos_y;
    // };

    this.editor.start();

    window.drawflowEditor = this.editor;
    const data = document.querySelector('[name="modelo_fluxo[drawflow_data]"]').value;
    if (data) {
      try {
        const json = JSON.parse(data);
        this.editor.import(json);
        setTimeout(() => this.markDestinoConnections(), 100); // small delay to ensure DOM rendered
      } catch(e) {
        console.error("Invalid drawflow_data:", e);
      }
    }

    this.setupDragAndDrop();
    this.setupPaletteDrag();
    this.setupFormSubmission();

    console.log("🎨 Drawflow ready");

    this.editor.on('nodeRemoved', (id) => {
      this.onNodeRemoved(id)
    })

    this.editor.on('connectionRemoved', (connection_data) => {
      this.onConnectionRemoved(connection_data)
    })
    
    // ⛔ Override node deletion if persisted
    const originalRemoveNode = this.editor.removeNodeId.bind(this.editor);
    const persistedNodes = JSON.parse(document.getElementById("persisted-nodes")?.dataset?.nodes || "[]");

    this.editor.removeNodeId = function (id) {
      const nodeKey = id.replace("-", "_")
      console.log(nodeKey, persistedNodes)
      if (persistedNodes.includes(nodeKey) || persistedNodes.includes(id)) {
        alert("Você não pode remover fases já salvas.");
        return;
      }
      originalRemoveNode(id);
    };

    // Lock nodes on canvas if persisted
    Object.values(this.editor.drawflow.drawflow.Home.data).forEach(node => {
      if (persistedNodes.includes(`node_${node.id}`)) {
        const el = document.getElementById(`node-${node.id}`);
        if (el) el.classList.add("locked-node");
      }
    });

    // Apenas uma conexão por conector
    this.editor.on('connectionCreated', (conn) => {
      const { output_id, output_class } = conn;

      const data = this.editor.drawflow.drawflow.Home.data;
      const node = data[output_id];
      if (!node) return;

      const output = node.outputs[output_class];
      if (!output) return;

      // Se esse output já tinha conexão antes desta, bloqueia
      if (output.connections.length > 1) {
        console.log(node)
        alert(`Fase já possui conexão padrão, use as condições.`)
        console.warn(`❌ Output ${output_class} já possui conexão. Removendo a extra.`);
        this.editor.removeSingleConnection(
          conn.output_id,
          conn.input_id,
          conn.output_class,
          conn.input_class
        );
      }
    });

  }

  disconnect() {
    if (window.drawflowEditor) {
      try {
        window.drawflowEditor.removeEvents?.()
      } catch (e) {
        console.warn("Failed to remove Drawflow events:", e)
      }
      window.drawflowEditor = null
    }

    window._stagedFlow = { fases: {} };
    window._usedNodes = [0];

  }

  setupDragAndDrop() {
    this.element.addEventListener("dragover", (e) => e.preventDefault());
    this.element.addEventListener("drop", (e) => {
      e.preventDefault();
      const nodeType = e.dataTransfer.getData("text/plain");
      if (!nodeType) return;

      const rect = this.element.getBoundingClientRect();
      window._drawflowLastDrop = {
        x: Math.round(e.clientX - rect.left),
        y: Math.round(e.clientY - rect.top),
      };

      if (nodeType === "fase") this.createNode();
    });
  }

  setupPaletteDrag() {
    document.addEventListener("dragstart", (e) => {
      const palette = e.target.closest && e.target.closest(".palette-item");
      if (!palette) return;
      e.dataTransfer.setData("text/plain", palette.dataset.nodeType || "fase");
    });
  }

  setupFormSubmission() {
    document.addEventListener("ajax:success", (event) => {
      const [data] = event.detail;
      if (!data) return;

      const nodeKey = window._editingNodeId || data.node_id; // e.g. "node_3"
      const isNewNode = !window._stagedFlow.fases[nodeKey]?.drawflowId;

      if (isNewNode) {
        // Node doesn’t exist yet — create it in Drawflow
        const drawflowId = this.addNode(
          nodeKey,
          data.nome,
          data.perfis.map((p) => p.nome)
        );

        // store staged data (returned payload might already contain campos/opcoes)
        window._stagedFlow.fases[nodeKey] = {
          ...data,
          drawflowId,
        };

        // Estou removendo a criação automática de conexões, achei que para fluxos complexos ficou pior
        // // Auto-connect to last node if it exists
        // const fases = Object.values(window._stagedFlow.fases);
        // if (fases.length > 1) {
        //   const lastFase = fases[fases.length - 2];
        //   const lastId = lastFase.drawflowId;
        //   const newId = drawflowId;

        //   const existingConnections =
        //     window.drawflowEditor.drawflow.drawflow.Home.data[lastId]?.outputs?.output_1?.connections || [];
        //   const alreadyConnected = existingConnections.some(c => c.node === newId);

        //   if (!alreadyConnected) {
        //     window.drawflowEditor.addConnection(lastId, newId, 'output_1', 'input_1');
        //   }
        // }

        // // After creating node, add destino connections for it
        // this.addDestinoConnectionsForNode(nodeKey);

      } else {
        // Node already exists — update its title/content and staged data
        this.updateNodeContent(nodeKey, data);
        window._stagedFlow.fases[nodeKey] = {
          ...window._stagedFlow.fases[nodeKey],
          ...data
        };

        // If it had previous destino connections, remove them, then re-add from updated data
        const drawflowId = window._stagedFlow.fases[nodeKey]?.drawflowId;
        if (drawflowId) {
          this.removeDestinoConnectionsForDrawflowId(drawflowId);
        }
        this.addDestinoConnectionsForNode(nodeKey);
      }

      // Hide modal after submit
      const modalEl = document.getElementById(`faseModal_${nodeKey}`);
      if (modalEl) {
        const bsModal = bootstrap.Modal.getOrCreateInstance(modalEl);
        bsModal.hide();
      }
    });

    document.addEventListener("ajax:error", (event) => {
      console.error("Erro na submissão do formulário da fase:", event);
      alert("Erro ao validar a fase.");
    });
  }

  /**
   * Remove red/destino connections that originate from a Drawflow numeric id.
   * Cleans DOM and updates editor.drawflow.drawflow.Home.data (outputs/inputs).
   */
  removeDestinoConnectionsForDrawflowId(drawflowId) {
    const editor = window.drawflowEditor;
    if (!editor) return;

    const data = editor.drawflow.drawflow.Home.data;
    const source = data[drawflowId];
    if (!source) return;

    // iterate outputs and remove connections that are not primary (output_1)
    Object.keys(source.outputs || {}).forEach(outputKey => {
      const output = source.outputs[outputKey];
      // make a copy because we'll mutate
      const conns = [...(output.connections || [])];

      conns.forEach(conn => {
        const targetId = conn.node;

        // consider destino connection if outputKey !== 'output_1' OR conn.input !== 'input_1'
        const isDestino = (outputKey !== 'output_1');
        if (!isDestino) return;

        // remove DOM element(s) for the connection (cover both naming styles)
        const sel1 = `.connection.node_out_node-${drawflowId}.node_in_node-${targetId}`;
        const sel2 = `.connection.node_out_${drawflowId}_node_in_${targetId}`;
        const el = document.querySelector(sel1) || document.querySelector(sel2);
        if (el) el.remove();

        // remove entry from source output connections
        output.connections = output.connections.filter(c => c.node !== targetId);

        // remove from target inputs
        const target = data[targetId];
        if (target && target.inputs) {
          Object.keys(target.inputs).forEach(inputKey => {
            const input = target.inputs[inputKey];
            console.log('debug',input, inputKey)
            input.connections = input.connections.filter(c => c.node !== drawflowId);

            // if this was an extra input (not input_1) and now empty, remove the input via editor helper
            if (inputKey !== 'input_1') {
              console.log('entrou')
              try { editor.removeNodeInput(targetId, inputKey); } catch(e){ /* ignore */ }
              // also delete from JSON to keep consistency
              delete target.inputs[inputKey];
            }
          });
        }
      });

      // if this output (non primary) has no connections left, remove it
      if (output.connections.length === 0 && outputKey !== 'output_1') {
        try { editor.removeNodeOutput(drawflowId, outputKey); } catch(e){ /* ignore */ }
        delete source.outputs[outputKey];
      }
    });
  }

  /**
   * Add destino connections for a given staged node key (e.g. "node_3").
   * Uses addConnector which will style connectors as red.
   */
  addDestinoConnectionsForNode(nodeKey) {
    if (!window._stagedFlow || !window._stagedFlow.fases) return;
    const fase = window._stagedFlow.fases[nodeKey];
    if (!fase || !fase.drawflowId) return;

    const fromDrawflowId = fase.drawflowId;
    const editor = window.drawflowEditor;
    const data = editor.drawflow.drawflow.Home.data;

    // For each campo -> opcoes / condicoes whose destino is a fase, create connector
    (fase.campos || []).forEach(campo => {
      (campo.opcoes || []).forEach(opcao => {
        const dest = opcao.destino_encoded;
        if (!dest || !dest.startsWith('fase:')) return;
        const targetNodeKey = dest.split(':')[1]; // e.g. "node_5"
        const target = window._stagedFlow.fases[targetNodeKey];
        if (!target || !target.drawflowId) return;
        const toDrawflowId = target.drawflowId;

        // check if connection already exists (any output)
        const already = Object.values(data[fromDrawflowId]?.outputs || {}).some(output =>
          output.connections.some(c => c.node == toDrawflowId)
        );
        if (!already) {
          // create a new connector (addConnector handles creating input/output slots and styling)
          this.addConnector(fromDrawflowId, toDrawflowId);
        }
      });

      (campo.condicoes || []).forEach(cond => {
        const dest = cond.destino_encoded;
        if (!dest || !dest.startsWith('fase:')) return;
        const targetNodeKey = dest.split(':')[1];
        const target = window._stagedFlow.fases[targetNodeKey];
        if (!target || !target.drawflowId) return;
        const toDrawflowId = target.drawflowId;

        const already = Object.values(data[fromDrawflowId]?.outputs || {}).some(output =>
          output.connections.some(c => c.node == toDrawflowId)
        );
        if (!already) {
          this.addConnector(fromDrawflowId, toDrawflowId);
        }
      });
    });

    // after adding, mark destino connections visually (your mark function)
    // small timeout to allow Drawflow to append DOM
    setTimeout(() => this.markDestinoConnections(), 50);
  }


  addNode(nodeId, etapaName, perfis = []) {
    const posX = window._drawflowLastDrop?.x || 100;
    const posY = window._drawflowLastDrop?.y || 100;

    const perfisHtml = perfis.length
      ? `<div class="node-perfis"><strong>Perfis:</strong><ul>${perfis
          .map((p) => `<li>${p}</li>`)
          .join("")}</ul></div>`
      : `<div class="node-perfis"><strong>Perfis:</strong><p class="text-muted">Nenhum perfil associado</p></div>`;

    const nodeHtml = `
      <div class="title-box">
        <span class="node-icon">⚡</span>
        <span class="node-title">${etapaName}</span>
      </div>
      <div class="box">
        ${perfisHtml}
      </div>
      <div class="footer-box">
        <a href="#" class="edit-node"
          data-action="click->drawflow#openNodeModal"
          data-node-id="${nodeId}">
          <span class="gear-icon">⚙️</span> Editar
        </a>
      </div>
    `;

    // Add node in Drawflow and store numeric ID
    const drawflowId = this.editor.addNode(
      "fase",
      1,
      1,
      posX,
      posY,
      "fase_" + nodeId,
      { node_id: nodeId },
      nodeHtml
    );

    console.log(`✅ Node "${etapaName}" added at (${posX}, ${posY}) with Drawflow ID ${drawflowId}`);
    return drawflowId;
  }

  createNode() {
    const i = window._usedNodes[window._usedNodes.length - 1];
    if (i === 51) alert("Limite de 50 nodes atingido!");
    const nodeId = `node_${i+1}`;
    if (!window._stagedFlow.fases[nodeId]) {
      window._editingNodeId = nodeId;

      const modalEl = document.getElementById(`faseModal_${nodeId}`);

      const form = modalEl.querySelector("form");

      const bsModal = bootstrap.Modal.getOrCreateInstance(modalEl);
      bsModal.show();
      window._usedNodes.push(i+1);
    }
  }

  updateNodeContent(nodeId, data) {
    const fase = window._stagedFlow.fases[nodeId];
    if (!fase || !fase.drawflowId) return;

    const drawflowId = fase.drawflowId;
    const node = this.editor.getNodeFromId(drawflowId);
    if (!node) return;

    // 1️⃣ Build new HTML (reuse your addNode template logic)
    const perfisHtml = data.perfis.length
      ? `<div class="node-perfis"><strong>Perfis:</strong><ul>${data.perfis
          .map((p) => `<li>${p.nome}</li>`)
          .join("")}</ul></div>`
      : `<div class="node-perfis"><strong>Perfis:</strong><p class="text-muted">Nenhum perfil associado</p></div>`;

    const newHtml = `
      <div class="title-box">
        <span class="node-icon">⚡</span>
        <span class="node-title">${data.nome}</span>
      </div>
      <div class="box">
        ${perfisHtml}
      </div>
      <div class="footer-box">
        <a href="#" class="edit-node"
          data-action="click->drawflow#openNodeModal"
          data-node-id="${nodeId}">
          <span class="gear-icon">⚙️</span> Editar
        </a>
      </div>
    `;

    // 2️⃣ Update the DOM
    const nodeEl = document.querySelector(`#node-${drawflowId}`);
    if (nodeEl) {
      // Only update the content inside Drawflow's internal wrapper
      const contentEl = nodeEl.querySelector(".drawflow_content_node");
      if (contentEl) {
        contentEl.innerHTML = newHtml;
      }
    }

    // 3️⃣ Update Drawflow internal JSON too
    this.editor.drawflow.drawflow.Home.data[drawflowId].html = newHtml;

    // 4️⃣ Update staged data
    window._stagedFlow.fases[nodeId] = { ...fase, ...data };

    console.log(`🔄 Node "${data.nome}" (ID ${drawflowId}) updated in place`);
  }


  openNodeModal(event) {
    event.preventDefault();
    const nodeId = event.currentTarget.dataset.nodeId;
    window._editingNodeId = nodeId;

    const modalEl = document.getElementById(`faseModal_${nodeId}`);
    if (!modalEl) return;

    const bsModal = bootstrap.Modal.getOrCreateInstance(modalEl);
    bsModal.show();
  }

  // drawRedConnectorsFromFlow() {
  //   if (!window._stagedFlow || !window._stagedFlow.fases) return;

  //   for (const [sourceNodeId, sourceFase] of Object.entries(window._stagedFlow.fases)) {
  //     if (!sourceFase.drawflowId || !sourceFase.campos) continue;

  //     sourceFase.campos.forEach(campo => {

  //       campo.opcoes.forEach(opcao => {
  //         const destino = opcao.destino_encoded; // e.g. "fase:node_2"
  //         if (!destino) return;

  //         const [tipo, targetNodeId] = destino.split(":");
  //         if (tipo !== "fase") return; // only connect to other Fases

  //         const targetFase = window._stagedFlow.fases[targetNodeId];
  //         if (!targetFase || !targetFase.drawflowId) return;

  //         // Draw the connector
  //         this.addConnector(sourceFase.drawflowId, targetFase.drawflowId);
  //       });

  //       campo.condicoes.forEach(condicao => {
  //         const destino = condicao.destino_encoded; // e.g. "fase:node_2"
  //         if (!destino) return;

  //         const [tipo, targetNodeId] = destino.split(":");
  //         if (tipo !== "fase") return; // only connect to other Fases

  //         const targetFase = window._stagedFlow.fases[targetNodeId];
  //         if (!targetFase || !targetFase.drawflowId) return;

  //         // Draw the connector
  //         this.addConnector(sourceFase.drawflowId, targetFase.drawflowId);
  //       });
  //     });



  //   }
  // }

  addConnector(sourceDrawflowId, targetDrawflowId) {
    // Checking if there is a connection
    const sourceNode = window.drawflowEditor.drawflow.drawflow.Home.data[sourceDrawflowId];
    const targetNode = window.drawflowEditor.drawflow.drawflow.Home.data[targetDrawflowId];

    if (!sourceNode || !targetNode) return;

    // Loop over all outputs of the source node
    const alreadyConnected = Object.values(sourceNode.outputs).some(output =>
      output.connections.some(conn => conn.node == targetDrawflowId)
    );

    if (alreadyConnected) {
      console.log(`Connection from ${sourceDrawflowId} to ${targetDrawflowId} already exists.`);
      return;
    }


    // Adding new connectors
    window.drawflowEditor.addNodeOutput(sourceDrawflowId)
    window.drawflowEditor.addNodeInput(targetDrawflowId)

    // Getting last connectors
    const in_keys = Object.keys(window.drawflowEditor.drawflow.drawflow.Home.data[targetDrawflowId].inputs)
    const in_connector = in_keys[in_keys.length - 1];

    const out_keys = Object.keys(window.drawflowEditor.drawflow.drawflow.Home.data[sourceDrawflowId].outputs)
    const out_connector = out_keys[out_keys.length - 1];

    // Adding the connetion
    window.drawflowEditor.addConnection(
      sourceDrawflowId,
      targetDrawflowId,
      out_connector,
      in_connector
    );

    // Making it red
    const paths = document.querySelectorAll(".connection");
    const lastSvg = paths[paths.length - 1];

    lastSvg.classList.add('custom-connector')

    const path = lastSvg.querySelector("path.main-path");

    if (path) {
      path.style.setProperty("stroke", "#ff4d4f", "important"); // red
      path.style.pointerEvents = "none"; // disables interaction
    }
  }

  // When a node is removed on drawflow, reset its references
  onNodeRemoved(id) {
    console.log('Node removed:', id)

    // The node ID in Drawflow
    const faseId = id
    const removedValue = `fase:node_${faseId}`;

    // Remove fase from our JSON
    delete _stagedFlow.fases[`node_${faseId}`]
    this.clearModal(`faseModal_node_${faseId}`)

    // Find all select fields that may reference it
    document.querySelectorAll('select[name*="[destino_encoded]"]').forEach(select => {
      if (select.value === removedValue) {
        this.resetToSeguirFluxo(select)
      }
    })

    // Clear _stagedFlow
    Object.values(_stagedFlow.fases).forEach(fase => {
    // Loop through campos
      if (!fase.campos) return;

      fase.campos.forEach(campo => {
        // Check opcoes
        if (campo.opcoes) {
          campo.opcoes.forEach(opcao => {
            if (opcao.destino_encoded === removedValue) {
              opcao.destino_encoded = "seguir_fluxo";
            }
          });
        }

        // Check condicoes
        if (campo.condicoes) {
          campo.condicoes.forEach(condicao => {
            if (condicao.destino_encoded === removedValue) {
              condicao.destino_encoded = "seguir_fluxo";
            }
          });
        }
      });
    });

  }


  // 🧩 Utility to set destino to "Seguir fluxo"
  resetToSeguirFluxo(select) {
    // 1️⃣ Reset the select element
    const seguirOption =
      Array.from(select.options).find(opt => opt.value === "seguir_fluxo") ||
      (() => {
        const o = document.createElement("option");
        o.value = "seguir_fluxo";
        o.textContent = "Seguir fluxo";
        select.appendChild(o);
        return o;
      })();

    select.value = "seguir_fluxo";
    select.dispatchEvent(new Event("change", { bubbles: true }));

  }


  // We need to clear the modal if we remove the Node
  clearModal(modalId) {
    const modal = document.getElementById(modalId)
    if (!modal) return

    // 1️⃣ Reset all form fields (input, select, textarea)
    modal.querySelectorAll('input, select, textarea').forEach(el => {
      const type = el.type
      if(type === 'submit') return;
      if (type === 'checkbox' || type === 'radio') {
        el.checked = false
      } else if (type === 'hidden' && el.name.endsWith('[_destroy]')) {
        // Reset hidden _destroy flags used by nested fields
        el.value = 'false'
      } else {
        el.value = ''
      }
    })

    // 2️⃣ Remove all nested fields dynamically added
    modal.querySelectorAll('.nested-fields').forEach(field => field.remove())

    // 3️⃣ (Optional) Re-hide add buttons if they depend on type logic
    modal.querySelectorAll('.add_opcao_btn, .add_condicao_btn').forEach(btn => {
      btn.classList.add('d-none')
    })

    // 4️⃣ (Optional) If using Stimulus controllers inside, you can also reinitialize
    // Stimulus normally reconnects automatically, but to be sure:
    if (window.Stimulus && window.StimulusApplication) {
      window.StimulusApplication.dispatch('reconnect')
    }
  }

  onConnectionRemoved(connection_data) {
    if(connection_data.output_class.endsWith("_1") || connection_data.input_class.endsWith("_1")) return;
    this.editor.removeNodeInput(connection_data.input_id, connection_data.input_class)
    this.editor.removeNodeOutput(connection_data.output_id, connection_data.output_class)
  }

  markDestinoConnections() {
    const homeData = this.editor.drawflow.drawflow.Home.data;
    
    Object.values(homeData).forEach(node => {
      const nodeId = node.id;

      // 🔹 Outgoing connections
      Object.entries(node.outputs).forEach(([outputKey, output]) => {
        const outputIndex = parseInt(outputKey.replace("output_", ""));
        output.connections.forEach(conn => {
          const targetNodeId = conn.node;
          const inputKey = conn.output;
          const inputIndex = parseInt(inputKey.replace("input_", ""));

          // If not first input/output, mark as destino
          if (outputIndex > 1 || inputIndex > 1) {
            const connEl = document.querySelector(
              `.connection.node_in_node-${targetNodeId}.node_out_node-${nodeId}`
            );
            connEl?.classList.add("destino-connection");
          }
        });
      });
    });
  }
  
  refreshNodeDestinoConnections(nodeId) {
    const editor = window.drawflowEditor;
    const data = editor.drawflow.drawflow.Home.data;
    const fase = window._stagedFlow.fases[nodeId];
    if (!fase || !fase.drawflowId) return;
    const fromId = fase.drawflowId;

    // 1️⃣ Remove old red connections from this node
    document.querySelectorAll(`.connection[data-from='${fromId}'][data-destino='true']`).forEach(el => el.remove());

    // 2️⃣ Rebuild only destino connections for this node
    if (!fase.campos) return;
    fase.campos.forEach(campo => {
      campo.opcoes?.forEach(opcao => {
        if (opcao.destino_encoded?.startsWith("fase:")) {
          const toNodeId = opcao.destino_encoded.split(":")[1];
          const target = window._stagedFlow.fases[toNodeId];
          if (target?.drawflowId) {
            const toId = target.drawflowId;

            // Prevent duplicate
            const existing = data[fromId]?.outputs?.output_2?.connections?.some(c => c.node == toId);
            if (!existing) {
              editor.addConnection(fromId, toId, "output_2", "input_2");
            }

            // Style it red
            const conn = document.querySelector(
              `.connection.node_in_${toId}_node_out_${fromId}`
            );
            if (conn) {
              conn.dataset.destino = "true";
              conn.dataset.from = fromId;
              conn.querySelector("path").style.stroke = "red";
              conn.querySelector("path").style.strokeWidth = "2.5px";
            }
          }
        }
      });
    });
  }


}
